module.exports = __webpack_public_path__ + "img/img38.473b029c.jpg";